import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = props => {
  const handleChange = e => {
    props.onChange(props.name, e.target.checked);
  };
  return (
    <div>
      <input
        id={props.id}
        type="checkbox"
        name={props.name}
        value={props.value}
        onChange={handleChange}
        checked={props.value}
        disabled={props.disabled}
      />
      <label htmlFor={props.name}>{props.label}</label>
    </div>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

export default Checkbox;
